export const CATEGORY_ORDER = [
  ['27', '8', '111', '17', '0'],
  ['35', '39', '23', '95', '91', '100', '47'],
  ['59', '61'],
];

export const EQUIPS_ORDER = [
  ['oldBuilding.true', 'newBuilding.true', 'firstUsage.true'],
  [
    'disabledFriendly.true',
    'hasBalcony.true',
    'hasParking.true',
    'hasGarden.true',
    'hasCellar.true',
    'hasKitchen.true',
    'hasLift.true',
    'hasTerrace.true',
  ],
];

export const AUSTRIA_COUNTRY_CODE = 'AT';

export const COUNTRIES_ORDER = [[AUSTRIA_COUNTRY_CODE], ['DE', 'IT', 'HR', 'CH', 'HU']];
